import req from "../http";

const recruitmentMethod = {
  // 取得 招募方式
  getRecruitmentMethod(params) {
    return req("get", "/BasicInformation/RecruitmentMethod", params);
  },
};

export default recruitmentMethod;